import z from 'zod';

export const connectionsWizardSchema = z.record(
  z.string(),
  z.object({
    projectId: z.string(),
    projectConnectionId: z.number().optional(),
    surveys: z
      .record(
        z.string(),
        z.object({
          surveyId: z.string(),
          surveyConnectionId: z.number().optional(),
        })
      )
      .optional(),
  })
);
